export enum JobSearchContextEnum {
  Default = 'default',
  Application = 'application',
  Bookmark = 'bookmark',
  Company = 'company',
  Partner = 'partner',
}
